export enum OccupancyTypes {
  OWNEROCC = 1,
  LANDLORD = 2,
  TENANTPERM = 3,
}
